/* eslint-disable import/prefer-default-export, no-underscore-dangle */
import { create } from 'zustand';
import { nanoid } from 'nanoid';

export const style1 = 'logo-max text-dark-deep border-b border-white/10 bg-transparent';
export const style2 = 'logo-min bg-purple-7/90 backdrop-blur-lg text-white';
// Variante claire (homepage v5) : fond blanc, texte sombre, logo foncé.
// État initial sur la homepage v5 : liens blancs sur le hero.
export const style1Hero = `${style1} header-hero`;
export const style2Light = 'logo-min header-light bg-white/95 backdrop-blur-lg text-was-ink';

const useZusHomeStore = create((set, get) => ({
  // Initialiser avec style1 (transparent) + fixed pour éviter le flash au chargement
  headerBackground: `${style1} fixed `,
  styleBk: 'style1',
  extWebpJpg: 'webp',
  initCall: ({ comefrom }) => {
    if (get().called) return null;
    return null;
  },
  setHeaderBackground2: (style) => set((state) => {
    // console.log('state.noFixedHeader', state.noFixedHeader, style);
    // Header blanc partout ; seule la homepage (lightScrolled + hero) garde l'état transparent en haut de page.
    const styles = {
      style1: state.lightScrolled ? style1Hero : style2Light,
      style2: style2Light,
      classDefault: state.classDefault,
    };

    let styleFinal = '';
    if (style === 'classDefault') styleFinal += styles.classDefault;
    else if (!style || !styles[style]) styleFinal += styles.style1;
    else styleFinal += styles[style];
    // console.log('state.noFixedHeader', style, state.noFixedHeader);
    if (!state.noFixedHeader) styleFinal += ' fixed ';
    return {
 ...state, headerBackground: styleFinal, called: nanoid(), styleBk: style,
};
  }),
}));

export const isInit = () => !!useZusHomeStore.getState()?._initFromApp;

export function initData(initDataData) {
  const initFromApp = useZusHomeStore.getState()?._initFromApp;
  if (initFromApp) return null;
  useZusHomeStore.setState({
    ...initDataData,
    _initFromApp: true,
  });
  return null;
}

export {
  useZusHomeStore,
};

export default useZusHomeStore;
